module.exports = __webpack_public_path__ + "img/352c1095755eb7b4d2508fbcc2f850c.8bd11717.b9554f9e.png";